import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { media } from '@/styles/responsive';
import { NavLink } from 'react-router';
import { bodySmall } from '@/styles/typography';
import { flex } from '@/styles/layout';
import { resetList } from '@/styles/common';

export const SupportMenuWrapper = styled.div`
  border-bottom: 1px solid ${COLORS.grey[850]};
  padding: 16px 20px;

  ${media.mobile`
    padding: 16px 16px;
  `}
`;

export const SupportMenuItem = styled.li`
  position: relative;

  &:last-child {
    &::after {
      top: 0;
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: 22px;
    height: 50%;
    background-color: ${COLORS.grey[850]};
    width: 1px;
    top: 50%;
    bottom: 0;
  }
`;

export const SupportMenuLink = styled(NavLink)`
  position: relative;
  ${flex({ alignItems: 'center' })};
  column-gap: 20px;
  padding: 10px 20px;
  text-decoration: underline;
  ${bodySmall};
  color: ${COLORS.grey[600]};
  word-break: break-all;
`;

export const SupportMenuSection = styled.ul`
  ${flex({ flexDirection: 'column' })};
  ${resetList};
`;

export const SupportMenuMarker = styled.div`
  height: 100%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: relative;
    width: 5px;
    height: 5px;
    background-color: ${COLORS.grey[700]};
    border-radius: 50%;
    z-index: 1;
  }
`;
